import { Injectable } from '@angular/core';
import * as firebase from 'firebase';
import { AngularFireAuth } from 'angularfire2/auth';
import { UsersService } from '../services/users.service';



@Injectable({
  providedIn: 'root'
})
export class AuthService {

  provider: firebase.auth.GoogleAuthProvider;
  constructor(public afAuth: AngularFireAuth, private usersService : UsersService) {
    this.provider = new firebase.auth.GoogleAuthProvider();
  }

  loginWithGoogle() {
    return this.afAuth.auth.signInWithPopup(this.provider);
  }

  loginWithEmail(email:string, password:string){
  
   return this.afAuth.auth.signInWithEmailAndPassword(email, password).then((data: firebase.User)=>{
     return firebase.auth().currentUser.getIdToken(true).then((idToken) => {
      return this.usersService.checkUserRight(idToken, firebase.auth().currentUser.uid);
      })   
    })      
    .catch(function(error) {
      var errorCode = error.code;
      var errorMessage = error.message;

      return errorMessage;
    });
  }

  logout() {    
    return firebase.auth().signOut();
  }
}
